import Vue from "vue";
import common from "../../../common";
import utilities_ from "../../utilities";
import HotEditableTextboxComponent_ from "./HotEditableTextboxComponent";
import HotEditableSelectComponent_ from "./HotEditableSelectComponent";
import HotEditableDatePickerComponent_ from "./HotEditableDatePickerComponent";
import HotEditableCheckboxComponent_ from "./HotEditableCheckboxComponent";
import HotEditableButtonComponent_ from "./HotEditableButtonComponent";
import HotEditableMessageComponent_ from "./HotEditableMessageComponent";
import HotEditableDoubleSelectsComponent_ from "./HotEditableDoubleSelectsComponent";
import HotEditableAddressComponent_ from "./HotEditableAddressComponent";
import HotEditableMultiSelectComponent_ from "./HotEditableMultiSelectComponent";
import HotEditableImageUploadComponent_ from "./HotEditableImageUploadComponent";
import HotEditableDocumentUploadComponent_ from "./HotEditableDocumentUploadComponent";
import HotEmbeddedFormComponent_ from "./HotEmbeddedFormComponent";
import HotEditableHiddenFieldComponent_ from "./HotEditableHiddenFieldComponent";
import HotEditableDocumentsUploadComponent_ from "./HotEditableDocumentsUploadComponent";
// import HotEditableFormManager_ from "./HotEditableFormManager";

declare function require(module: string): unknown;
const utilities = require("../../utilities") as typeof utilities_;
const HotEditableTextboxComponent = require("./HotEditableTextboxComponent") as HotEditableTextboxComponent_;
const HotEditableSelectComponent = require("./HotEditableSelectComponent") as HotEditableSelectComponent_;
const HotEditableDatePickerComponent = require("./HotEditableDatePickerComponent") as HotEditableDatePickerComponent_;
const HotEditableCheckboxComponent = require("./HotEditableCheckboxComponent") as HotEditableCheckboxComponent_;
const HotEditableButtonComponent = require("./HotEditableButtonComponent") as HotEditableButtonComponent_;
const HotEditableMessageComponent = require("./HotEditableMessageComponent") as HotEditableMessageComponent_;
const HotEditableDoubleSelectsComponent = require("./HotEditableDoubleSelectsComponent") as HotEditableDoubleSelectsComponent_;
const HotEditableAddressComponent = require("./HotEditableAddressComponent") as HotEditableAddressComponent_;
const HotEditableMultiSelectComponent = require("./HotEditableMultiSelectComponent") as HotEditableMultiSelectComponent_;
const HotEditableImageUploadComponent = require("./HotEditableImageUploadComponent") as HotEditableImageUploadComponent_;
const HotEditableDocumentUploadComponent = require("./HotEditableDocumentUploadComponent") as HotEditableDocumentUploadComponent_;
const HotEmbeddedFormComponent = require("./HotEmbeddedFormComponent") as HotEmbeddedFormComponent_;
const HotEditableHiddenFieldComponent = require("./HotEditableHiddenFieldComponent") as HotEditableHiddenFieldComponent_;
const HotEditableDocumentsUploadComponent = require("./HotEditableDocumentsUploadComponent") as HotEditableDocumentsUploadComponent_;

class HotEditableFormLoader {
    /** Attribut permettant d'identifier qu'un element doit etre transforme en tag HE */
    private static readonly _rootAttribute = "hot-editable";
    /** Liste des tags HE supportant l'ajout de HotEditableMessage */
    private static readonly _tagNamesWithMessageSupport = [
        HotEditableTextboxComponent_.tagName,
        HotEditableCheckboxComponent_.tagName,
        HotEditableDatePickerComponent_.tagName,
        HotEditableSelectComponent_.tagName,
        HotEditableMultiSelectComponent_.tagName
    ];

    // STATIC METHODS
    static prepareComponentsMarkupFromTarget(appendFieldMessages?: boolean, appendConcurrencySumCheck?: boolean, rootId?: string) {
        appendFieldMessages = appendFieldMessages === true;//Default is FALSE
        appendConcurrencySumCheck = appendConcurrencySumCheck !== false;//Default is TRUE

        const rootTarget = rootId ? '#' + rootId : 'body';
        const $root = $(rootTarget);
        const $hotEditable = $root.find('[' + HotEditableFormLoader._rootAttribute + ']');

        for (let i = 0; i < $hotEditable.length; i++) {
            const el = $hotEditable[i];
            const $he = $(el);
            const he = $he.attr(HotEditableFormLoader._rootAttribute);

            if (he === 'message') {
                HotEditableMessageComponent_.prepareMarkup(el);
                continue;
            }

            if ($he.is("select")) {
                if (el.hasAttribute('multiple'))
                    HotEditableMultiSelectComponent_.prepareMarkup(el as HTMLSelectElement);
                else
                    HotEditableSelectComponent_.prepareMarkup(el as HTMLSelectElement);
                continue;
            }

            if ($he.is('button')) {
                HotEditableButtonComponent_.prepareMarkup(el);
                continue;
            }

            const t = $he.attr('type');

            if (t === 'date' || he === 'datepicker') {
                HotEditableDatePickerComponent_.prepareMarkup(el);
                continue;
            }

            if (t === 'checkbox' || he === 'checkbox') {
                HotEditableCheckboxComponent_.prepareMarkup(el);
                continue;
            }

            if (t === 'hidden' || he === 'hiddenfield') {
                HotEditableHiddenFieldComponent_.prepareMarkup(el);
                continue;
            }

            //if(!t||t==='text'||t==='password'||t==='textbox')
            HotEditableTextboxComponent_.prepareMarkup(el);
        }

        if (appendFieldMessages)
            this.appendFieldMessageComponents($root, el => {
                const intervaleEl = el.closest('.mfrm-intervales-to, .mfrm-intervales-to');
                return !intervaleEl ? el : intervaleEl;
            });

        if (appendConcurrencySumCheck)
            this.appendConcurrencySumCheckField($root, rootId);

        return this;
    }

    static loadComponentsFromParent(parent: common.IHotEditableFormVue) {
        const o = {} as any;

        o[HotEmbeddedFormComponent_.tagName] = HotEmbeddedFormComponent;
        o[HotEditableSelectComponent_.tagName] = HotEditableSelectComponent;
        o[HotEditableMultiSelectComponent_.tagName] = HotEditableMultiSelectComponent;
        o[HotEditableCheckboxComponent_.tagName] = HotEditableCheckboxComponent;
        o[HotEditableDatePickerComponent_.tagName] = HotEditableDatePickerComponent;
        o[HotEditableTextboxComponent_.tagName] = HotEditableTextboxComponent;
        o[HotEditableImageUploadComponent_.tagName] = HotEditableImageUploadComponent;
        o[HotEditableDocumentUploadComponent_.tagName] = HotEditableDocumentUploadComponent;
        o[HotEditableDocumentsUploadComponent_.tagName] = HotEditableDocumentsUploadComponent;
        o[HotEditableButtonComponent_.tagName] = HotEditableButtonComponent;
        o[HotEditableMessageComponent_.tagName] = HotEditableMessageComponent;
        o[HotEditableDoubleSelectsComponent_.tagName] = HotEditableDoubleSelectsComponent;
        o[HotEditableAddressComponent_.tagName] = HotEditableAddressComponent;
        o[HotEditableHiddenFieldComponent_.tagName] = HotEditableHiddenFieldComponent;
        //o[HotEditableTinymceComponent_.tagName] = HotEditableTinymceComponent;

        (parent as any as Vue).$options.components = o;
    }

    /** Inject le hidden field de la concurrence. Requiere la presence d'un tag "form" incluant l'attribut "vue-id" dont la valeur est identique a cette du "id" du module vue racine. */
    private static appendConcurrencySumCheckField($root: JQuery, rootId?: string) {
        if (!$root)
            throw "L'argument '$root' est NULL.";
        var form: any;
        if ($root.is("form")) {
            form = $root;
        } else {
            var target = rootId ? "form[vue-id='" + rootId + "']" : "form";
            form = $root.find(target);

            // Decommenter pour trouver le formulaire dont le "vue-id" est manquant.
            // if (!form.length)
            //     throw "Le formulaire correspondant a la cible '" + target + "' n'existe pas.";
        }

        if (form?.length) {
            const field = document.createElement(HotEditableHiddenFieldComponent_.tagName);
            const name = "ConcurrencySumCheck";
            field.setAttribute("init-name", name);
            field.setAttribute("init-id", name + "_" + utilities.createGuid("N"));
            form[0].appendChild(field);
        }
    }

    // private static appendDefaultMessageComponent($root: JQuery) {
    //     const form = $root.find('form');
    //     if (!form.length)
    //         return;

    //     const message = document.createElement(HotEditableMessageComponent_.tagName);
    //     const name = "DefaultFormMessage";
    //     message.setAttribute("init-name", name);
    //     message.setAttribute("init-id", name + "_" + utilities.createGuid("N"));
    //     form[0].prepend(message);
    // }

    private static appendFieldMessageComponents($root: JQuery, getFromField?: (el: Element) => Element) {
        for (let i = 0; i < this._tagNamesWithMessageSupport.length; i++) {
            const elements = $root.find(this._tagNamesWithMessageSupport[i]);
            if (elements)
                for (let j = 0; j < elements.length; j++)
                    this.appendFieldMessageComponent(elements[j], getFromField);
        }
    }

    private static appendFieldMessageComponent(el: Element, getFromField?: (el: Element) => Element) {
        if (!el)
            throw "L'argument 'el' est requis.";
        const messageEl = document.createElement(HotEditableMessageComponent_.tagName);
        const refId = el.getAttribute('init-id');
        if (!refId)
            throw "L'attribut 'init-id' n'existe pas.";
        const refFieldName = el.getAttribute('init-name');
        if (!refFieldName)
            throw "L'attribut 'init-name' du champs en refere n'existe pas.";
        messageEl.setAttribute('init-id', 'HEMessage_' + refId);
        messageEl.setAttribute('init-field-name', refFieldName);
        messageEl.setAttribute('init-mode', common.HotEditableFormMessageModes.field)
        messageEl.setAttribute('v-bind:init-auto-close-on-form-action', 'true');

        if (el.parentNode) {
            if (getFromField) {
                el = getFromField(el);
                if (!el)
                    utilities.printError("L'élement n'a pas de parent.");
            }

            el.parentNode?.appendChild(messageEl);

            (getFromField ? getFromField(el) : el);
        } else utilities.printError("L'élement n'a pas de parent.");
    }
}
export = HotEditableFormLoader;